import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { MiGrid2Component } from 'app/modules/shared/components/mi-grid-2/mi-grid-2.component';
import { UiService } from 'app/modules/shared/services/ui.service';
import { AppSettings } from '../../../shared/app.settings';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { BookingService } from 'app/modules/bookings/services/booking.service';
// import { formatTimeInAmPmCell } from 'app/modules/shared/utility-functions/grid';

@Component({
  selector: 'app-assign-driver-to-journey',
  templateUrl: './assign-driver-to-journey.component.html',
  styleUrls: ['./assign-driver-to-journey.component.scss']
})
export class AssignDriverToJourneyComponent implements OnInit {
  @ViewChild(MiGrid2Component) grid2Ref: MiGrid2Component;

  // Trip Details
  tripId: string = '';
  tripDetails: any = null;
  isAccordionOpen: boolean = false;

  // Filter Options
  weeklyOffOptions: any[] = [];
  selectedWeeklyOff: string = '';

  dutyStatusOptions: any[] = [];
  selectedDutyStatus: string = '';
  vehicleTypeOptions: any[] = [];
  selectedVehicleType: string = '';
  sortByOptions: any[] = [
    { label: 'Nearby', value: 'nearby' },
    { label: 'Availability', value: 'availability' },
    { label: 'Rating', value: 'rating' }
  ];
  selectedSortBy: string = 'nearby';

  searchText: string = '';

  // Grid Configuration
  url;
  urlTemp: string = '/secure/drivers/assign-trip/v1/list';
  gridColumn: any[] = [];
  actionButtons: any[] = [];
  params: string = '';
  placeholderText = "Search by driver name";
  // Rest Period Dialog
  showRestPeriodDialog: boolean = false;
  restPeriodReason: string = '';
  selectedDriverData: any = null;
  messageForAssignDriverPopup = '';
  messageHeaderForAssignDriverPopup = '';
  buttonLabel: string = 'Assign';
  isSupervisorRole: boolean = false;
  userDetails: any;
  storeUnit: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private commonBindingDataService: CommonBindingDataService,
    private bookingService: BookingService,
    private uiService: UiService,
    private confirmationService: ConfirmationService,
    private storageService: StorageService,
  ) {

  }

  ngOnInit() {
    this.storeUnit = this.commonBindingDataService.getTenantConfigValue(AppSettings.DISTANCE_UNIT);
    this.userDetails = this.storageService.getItem(AppSettings.USER_DETAILS);
    this.getCarTypes();
    this.initializeGridColumns();
    this.initializeActionButtons();
    this.initializeFilterOptions();

    // Get trip ID from route params
    this.tripId = this.route.snapshot.queryParams['id'] || 'NA';
    // Load trip details
    this.loadTripDetails();
  }

  getCarTypes() {
    this.commonBindingDataService.getVehicleType().subscribe(results => {
      this.vehicleTypeOptions = [];
      results.forEach(element => {
        this.vehicleTypeOptions.push({ label: element.vehicleType, value: element.id });
      });
    }, (error) => {
      this.uiService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
    });
  }

  //  private getSearchUrl() {
  //   if (!this.bookingBoolean) {
  //     if (this.url !== null && this.url !== '') {
  //       return `${this.url}?serviceTypeIds=${this.serviceIds && this.serviceIds.toString() || ''}&searchText=${this.searchText}`;
  //     } else {
  //       return `${this.urlDisp}?searchText=${this.searchText}&roleCode=${this.roleCode}`;
  //     }
  //   } else {
  //     if (this.url !== null && this.url !== '') {
  //       return `${this.url}?serviceTypeId=${this.serviceIds && this.serviceIds.toString() || ''}&` +
  //         `searchText=${this.searchText}&vehicleTypeId=${this.vehicleTypeId && this.vehicleTypeId.toString() || ''}` +
  //         `&latitude=${this.latitude}&longitude=${this.longitude}&bookingid=${this.bookingId}&bookLater=${this.bookLater}` +
  //         `&pickupDateTime=${this.pickupDateTime? this.pickupDateTime: ''}`;
  //     }
  //   }
  // }
  initializeFilterOptions() {
    // Weekly Off Options
    // this.weeklyOffOptions = this.storageService.getItem(AppSettings.DRIVER_WEEKLY_OFF);

    this.dutyStatusOptions = [
      { label: 'All', value: '' },
      { label: 'Online', value: 'Online' },
      { label: 'Offline', value: 'Offline' },
      { label: 'Busy', value: 'Busy' },
      { label: 'Idle', value: 'Idle' }
    ];
  }

  initializeGridColumns() {
    this.gridColumn = [
      {
        header: this.commonBindingDataService.getLabel('label_driver'),
        field: 'name',
        sort: true,
        cellRendererHtml: this.colDriverInfo,
      },
      {
        header: this.commonBindingDataService.getLabel('label_vehicle_info'),
        field: 'makeModel',
        sort: false,
        cellRendererHtml: this.colVehicleInfo,
      },
     
      {
        header: this.commonBindingDataService.getLabel('label_assigned_trips'),
        field: 'assignedTrips',
        sort: false,
        cellRendererHtml: this.colAssignedTrips,
      },
    
      {
        header: this.commonBindingDataService.getLabel('label_distance'),
        field: 'distance',
        sort: true,
        cellRendererHtml: this.colEtaDistanceInfo,

      },
    ];
  }

  initializeActionButtons() {
    this.actionButtons = [
      {
        field: 'ASSIGN-DRIVER-TRIP',
        class: 'ASSIGN-DRIVER-TRIP',
        show: (data) => {
          const isDisabled = (this.tripDetails?.driverInfo?.id && this.tripDetails.driverInfo.id === data.userId) ? 'disabled-btn' : '';
          return `<div class="assign-driver-btn ${isDisabled}" title="${this.buttonLabel}">${this.buttonLabel}</div>`;
        }
      }
    
    ];
  }

  colDriverInfo = (params) => {
    let driverInfo = '';
    if (params?.name) {
      const phone = params.phoneNumber;
      driverInfo = `<div class="grid-comman-col">
      <div title="${params.name}">
      <span class="fa fa-circle" style="color: ${params.driverStatus === 'ONLINE' ? '#068b06a3' : params.driverStatus === 'BUSY' ? '#ff0000b0':'#8080804a'};margin-left: -12px;font-size:12px"></span>
        ${params.name}</div>
        
        <div title="${phone}" class="comman-col-secondary-text">${phone}</div>
      </div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML = driverInfo;
    return eDiv;
  }

  colVehicleInfo = (params) => {
    let vehicleInfo = '';
    if (params?.vehicleNumber) {
      const model = params?.modelName ? `${params?.makeModel} ${params?.modelName} ${params?.vehicleType ? `(${params?.vehicleType})` : ''}` : params?.makeModel;
      vehicleInfo = `<div class="grid-comman-col">
        <div title="Vehicle number">${params?.vehicleNumber}</div>
        <div title="Model" class="comman-col-secondary-text">${model}</div>
      </div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML = vehicleInfo;
    return eDiv;
  }


  colAssignedTrips = (params) => {
    const completed = params?.completedTrips || 0;
    const upcoming = params?.upcomingTrips || 0;
    const assignedInfo = `<div class="grid-comman-col">
    <div style="line-height:1.8">
      <div title="${completed + ' Completed'}">${completed + ' Completed'}</div>
      <div title="${upcoming + ' Assigned'}">${upcoming + ' Assigned'}</div>
      </div>
    </div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = assignedInfo;
    return eDiv;
  }

  colEtaDistanceInfo = (params) => {
    let distanceUnitStr = '';
    if(this.storeUnit.toLowerCase() === AppSettings.DISTANCE_UNIT_MILES) {
      distanceUnitStr = params?.distance ? `${params?.distance / 1.60934} miles  |  ${params?.etaWithUnit}` : 'NA';
    } else {
      distanceUnitStr = params?.distance ? `${params?.distance / 1000} km  |  ${params?.etaWithUnit}` : 'NA';
    }

    const distanceStr = params?.distance ? `${distanceUnitStr}` : 'NA';
    const assignedInfo = `<div class="grid-comman-col">
      <div title="${distanceStr}">${distanceStr}</div>
    </div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = assignedInfo;
    return eDiv;
  }

  loadTripDetails() {
    this.bookingService.fetchTourBooking(this.tripId).subscribe(
      (data) => {
        this.tripDetails = data;
        // Initialize grid
        this.selectedVehicleType = this.tripDetails.tourBookingInfo.vehicleTypeId;
        if (this.tripDetails && this.tripDetails.vehicleInfo && this.tripDetails.vehicleInfo.vehicleNumber) {
          this.buttonLabel = 'Reassign';
        } else {
          this.buttonLabel = 'Assign';
        }

        // this.selectedDutyStatus = 
        this.onFilterChange();
      },
      (error) => {
        this.uiService.showMessage(AppSettings.SEVERITY.ERROR, 'Failed to load trip details');
      }
    );

    //  setTimeout(() => {
    //     if (this.grid2Ref) {
    //       this.url = this.urlTemp;
    //       this.params = `?serviceTypeId=${this.tripDetails.tourBookingInfo.serviceTypeId}&` +
    //         `searchText=${this.searchText}&vehicleTypeId=${this.tripDetails.tourBookingInfo.vehicleTypeId && this.tripDetails.tourBookingInfo.vehicleTypeId.toString() || ''}` +
    //         `&latitude=${this.tripDetails.tourBookingInfo.sourceLatitude}&longitude=${this.tripDetails.tourBookingInfo.sourceLongitude}&bookingid=${this.tripDetails.tourBookingInfo.id}&bookLater=${this.tripDetails.tourBookingInfo.bookLater}` +
    //         `&pickupDateTime=${this.tripDetails.tourBookingInfo.pickupDateTime ? this.tripDetails.tourBookingInfo.pickupDateTime : ''}`
    //       // this.params = '?activatedStatus=Active&status=Available';
    //       this.grid2Ref.updateUrl(this.url + this.params);
    //     }
    //   }, 0);
  }

  toggleAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen;
  }

  onFilterChange() {
    this.url = this.urlTemp + `/${this.selectedVehicleType}`;
    this.params = '?tourId=' + this.tripId;
   
    // this.params = `?serviceTypeId=${this.tripDetails.tourBookingInfo.serviceTypeId}` +
    //   `&latitude=${this.tripDetails.tourBookingInfo.sourceLatitude}&longitude=${this.tripDetails.tourBookingInfo.sourceLongitude}&bookingid=${this.tripDetails.tourBookingInfo.id}&bookLater=${this.tripDetails.tourBookingInfo.rideLater}` +
    //   `&pickupDateTime=${this.tripDetails.tourBookingInfo.pickupDateTime ? this.tripDetails.tourBookingInfo.pickupDateTime : ''}`


    // if (this.selectedVehicleType) {
    //   this.params += '&vehicleTypeId=' + this.selectedVehicleType;
    // }

    if (this.selectedDutyStatus) {
      this.params += '&driverStatus=' + this.selectedDutyStatus;
    }

    // if (this.selectedWeeklyOff) {
    //   this.params += '&driverWeeklyOff=' + this.selectedWeeklyOff;
    // }

    // if (this.selectedSortBy) {
    //   this.params += '&sortBy=' + this.selectedSortBy;
    // }

    // this.url = this.urlTemp + this.params;
    this.url = this.url + this.params;
    console.log(this.url, 'this.url');

    if(this.grid2Ref) {
      this.grid2Ref.updateUrl(this.url);
    }
    // this.grid2Ref.updateUrl(this.url + this.params);
  }

  onReset() {
    this.selectedDutyStatus = '';
    this.selectedVehicleType = this.tripDetails.tourBookingInfo.vehicleTypeId;
    this.selectedSortBy = 'nearby';
    // this.searchText: string = '';
    this.onFilterChange();
  }

  onApply() {
    this.onFilterChange();
  }

  onActionBtnClicked(e: any) {
    const data = e.row;
    const actionType = e.class;
    const assigningVehicleTypeId = data?.vehicleTypeId;
    const vehicleType = data?.vehicleType;


    if (this.tripDetails?.driverInfo?.id && this.tripDetails.driverInfo.id === data?.userId) {
      return;
    }

    switch (actionType) {
      case 'ASSIGN-DRIVER-TRIP':
        let messageHeader = 'Confirm Assignment';
        let message = 'Are you sure you want to assign this driver?';

        if(this.tripDetails.tourBookingInfo.vehicleTypeId !== assigningVehicleTypeId) {
          if (this.tripDetails && this.tripDetails.vehicleInfo && this.tripDetails.vehicleInfo.vehicleNumber) {
            messageHeader = 'Confirm Reassignment';
            message = `The requested vehicle type is <strong>${this.tripDetails.vehicleTypeInfo.vehicleType}</strong> and you are reassigning a <strong>${vehicleType}</strong>  vehicle. Are you sure you want to proceed?`;  
          } else {
            messageHeader = 'Confirm Assignment';
            message = `The requested vehicle type is <strong>${this.tripDetails.vehicleTypeInfo.vehicleType}</strong> and you are assigning a <strong>${vehicleType}</strong>  vehicle. Are you sure you want to proceed?`;  
          }
        } else {
          if (this.tripDetails && this.tripDetails.vehicleInfo && this.tripDetails.vehicleInfo.vehicleNumber) {
            messageHeader = 'Confirm Reassignment';
            message = 'Are you sure you want to reassign this driver?'
          }
        }
        //  messageHeader = (this.tripDetails && this.tripDetails.vehicleInfo && this.tripDetails.vehicleInfo.vehicleNumber) ? 'Confirm Reassignment' : 'Confirm Assignment';
        
         // let messageHeader = 'Confirm Reassignment';
        //  message = `The requested vehicle type is <strong>${this.tripDetails.vehicleTypeInfo.vehicleType}</strong> and you are assigning a <strong>${vehicleType}</strong>  vehicle. Are you sure you want to proceed?`;  

      // if(this.tripDetails.tourBookingInfo.vehicleTypeId !== vehicleTypeId) {
      //    message = `The requested vehicle type is <strong>${this.tripDetails.vehicleTypeInfo.vehicleType}</strong> and you are assigning a <strong>${vehicleType}</strong>  vehicle. Are you sure you want to proceed?`;  
      //   this.confirmationService.confirm({
      //       message: message,
      //       header: 'Confirm Assignment',
      //       icon: 'fa fa-question-circle',
      //       accept: () => {
      //         return this.onAssignDriver(data);
      //       }
      //     });
      //   }

        if (this.tripDetails && this.tripDetails.vehicleInfo && this.tripDetails.vehicleInfo.vehicleNumber) {
         this.confirmationService.confirm({
          message: message,
          header: messageHeader,
          icon: 'fa fa-question-circle',
          accept: () => {
            return this.onReassignDriver(data);
          }
         });
        } else {
          this.confirmationService.confirm({
            message: message,
            header: messageHeader,
            icon: 'fa fa-question-circle',
            accept: () => {
              return this.onAssignDriver(data);
            }
           });
        }
      default:
        break;
    }
  }

  onAssignDriver(driverData: any) {
    const driverId = driverData.userId;
    this.commonBindingDataService.driverAssigned(this.tripId, driverId).subscribe(results => {
      this.uiService.showMessage(AppSettings.SEVERITY.SUCCESS, results.general[0].message);
      setTimeout(() => {
        this.goBack();
      }, 1000);
    }, (error) => {
      this.uiService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
    });
  }

  onReassignDriver(driverData: any) {
    const driverId = driverData.userId;
    this.commonBindingDataService.driverReassigned(this.tripId, driverId).subscribe(results => {
      this.uiService.showMessage(AppSettings.SEVERITY.SUCCESS, results.general[0].message);
      setTimeout(() => {
        this.goBack();
      }, 1000);
    }, (error) => {
      this.uiService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
    });
  }

  // onAssignDriver(driverData: any) {
  //   console.log(driverData, 'driverData');
  //   const driverName = `${driverData.firstName} ${driverData.lastName || ''}`.trim();

  //   const assign = (this.tripDetails.driverInfo && this.tripDetails.driverInfo.firstName) ? 'reassign' : 'assign';
  //   const assignment = (this.tripDetails.driverInfo && this.tripDetails.driverInfo.firstName) ? 'reassignment' : 'assignment';
  //   this.messageForAssignDriverPopup = `Are you sure you want to ${assign} ${driverName} to this journey?`;
  //   this.messageHeaderForAssignDriverPopup = (this.tripDetails.driverInfo && this.tripDetails.driverInfo.firstName) ? 'Confirm Reassignment' : 'Confirm Assignment';

  //   // Normal assignment confirmation
  //   this.confirmationService.confirm({
  //     message: `Are you sure you want to ${assign} ${driverName} to this journey?`,
  //     header: this.messageHeaderForAssignDriverPopup,
  //     icon: 'fa fa-question-circle',
  //     accept: () => {
  //       this.proceedWithAssignment(driverData, null);
  //     }
  //   });
  // }



  proceedWithAssignment(driverData: any, reason: string | null) {
    const driverName = `${driverData.firstName} ${driverData.lastName || ''}`.trim();
    let overridden = driverData.status.toLowerCase() === 'weekly off' || driverData.status.toLowerCase() === 'rest period';
    console.log(driverData, 'driverData');
    // const assignDto = {
    //   tripId: this.tripId,
    //   driverId: driverData.id,
    //   vehicleId: driverData.vehicleId,
    //   // reason: reason,   
    //   overridden: overridden,   
    //   overrideReason: overridden? reason:'',
    //   overrideType: overridden? driverData.status: '',
    // };

    const assignDto = {
      driverId: driverData.driverId,
      overridden: overridden,
      overrideReason: overridden ? reason : '',
      overrideType: overridden ? driverData.status : '',
      driverDistanceAtAssignmentMtr: driverData.distance,
    };

    // Replace with actual API call
    // this.uiService.showMessage(AppSettings.SEVERITY.SUCCESS, 
    //   `${driverName} has been successfully assigned to the journey.`);

    // Navigate back after successful assignment
    // setTimeout(() => {
    //   this.goBack();
    // }, 1500);

    // Uncomment below for actual API call
    // this.bookingService.assignDriverV1(this.tripId, assignDto).subscribe(
    //   (response) => {
    //     this.uiService.showMessage(AppSettings.SEVERITY.SUCCESS,
    //       response.general[0].message);
    //     setTimeout(() => {
    //       this.goBack();
    //     }, 1500);
    //   },
    //   (error) => {
    //     this.uiService.showMessage(AppSettings.SEVERITY.ERROR,
    //       error.general[0].message);
    //   }
    // );
  }

  goBack() {
    this.location.back();
  }
}

